/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useMemo } from 'react';
import { Player } from '@lordicon/react';
import { Row, Col, Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import {
  useTranslator,
  useAppContext,
  formatCalories,
  formatDecimal,
} from '@front-activerse/common-components';

const DayPlanStats = ({ meals }) => {
  const { t } = useTranslator();
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const {
    lotties: { infoIcon },
  } = useAppContext();

  let sumKcal = 0;
  let sumProteins = 0;
  let sumFats = 0;
  let sumCarbs = 0;
  let sumFiber = 0;

  meals.forEach((meal) => {
    sumKcal += meal.kcal;
    sumProteins += meal.macro.protein.grams;
    sumFats += meal.macro.fat.grams;
    sumCarbs += meal.macro.carbohydrates.grams;
    sumFiber += meal.macro.dietaryFiberGrams ?? 0;
  });

  const playerRefInfo = useRef(null);
  const iconsIconMiddleColor = useMemo(() => {
    if (typeof document === 'undefined') return '#000000';
    const color = getComputedStyle(document.documentElement)
      .getPropertyValue('--icons-icon-middle-color')
      .trim();
    return color || '#000000';
  }, []);

  const round = (x) => {
    return Math.round(x * 10) / 10;
  };

  return (
    <>
      <Row>
        <Col xl={{ size: 8, offset: 2 }}>
          <div className="meal-plan-stats text-center">
            <div className="position-relative">
              <p className="mb-0 small medium text-text-main-color">
                {t('mealPlan.nutritionalInfo.calories.title')}: {formatCalories(sumKcal)} kcal
              </p>

              <Button
                color="link"
                className="p-0 position-absolute top-0 end-0"
                style={{ width: '16px', height: '16px', lineHeight: '0' }}
                onClick={toggleModal}
                onMouseEnter={() => playerRefInfo.current?.playFromBeginning()}
                onTouchStart={() => playerRefInfo.current?.playFromBeginning()}
              >
                <Player
                  ref={playerRefInfo}
                  icon={infoIcon}
                  size={14}
                  colorize={iconsIconMiddleColor}
                />
              </Button>
            </div>
            <hr className="my-m" />
            <Row className="divider2 text-center">
              <Col>
                <p className="mb-0 small medium text-text-main-color">{round(sumProteins)} g</p>
                <p className="description-small text-text-variant-color mb-0">
                  {t('mealPlan.nutritionalInfo.proteins.title')}
                </p>
              </Col>
              <Col>
                <p className="mb-0 small medium text-text-main-color">{round(sumFats)} g</p>
                <p className="description-small text-text-variant-color mb-0">
                  {t('mealPlan.nutritionalInfo.fats.title')}
                </p>
              </Col>
              <Col>
                <p className="mb-0 small medium text-text-main-color">{round(sumCarbs)} g</p>
                <p className="description-small text-text-variant-color mb-0">
                  {t('mealPlan.nutritionalInfo.carbs.title')}
                </p>
              </Col>
            </Row>
            {round(sumFiber) > 0 && (
              <>
                <hr className="my-m" />
                <div className="d-flex justify-content-center align-items-baseline gap-1">
                  <p className="mb-0 description text-text-variant-color">
                    {t('mealPlan.info.distribution.fiber')}:
                  </p>
                  <p className="mb-0 small medium text-text-main-color">
                    {formatDecimal(sumFiber)} g
                  </p>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>

      <Modal isOpen={showModal} toggle={toggleModal} centered size="md">
        <ModalBody>
          <h4 className="title-medium semi-bold">{t('mealPlan.calorieBasePopup.title')}</h4>
          <p className="text-text-variant-color multi-line">
            {t('mealPlan.calorieBasePopup.content.part1')}
          </p>
          <p className="text-text-variant-color multi-line mb-0">
            {t('mealPlan.calorieBasePopup.content.part2')}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" className="w-100" onClick={toggleModal}>
            {t('mealPlan.calorieBasePopup.button')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default DayPlanStats;
